// Created by wangziming on 2022/5/20 0002.
let voice = [
  {
    path: '/voice',
    name: '语音课',
    component: () => import('@/pages/voice/index')
  }
]

export default voice
